import forEach from '../../../../javascripts/dom/forEach';

const forms = document.querySelectorAll('[data-js-module="m-form"]');

const init = async () => {
  const { default: Form } = await import(/* webpackChunkName: "m-form" */ './form.js');

  forEach(forms, (index, element) => new Form(element));
};

if (forms.length) init();
